// =============================================================================
// src/rules/deck-validation.js  —  shared deck/card legality
// -----------------------------------------------------------------------------
// SHARED RULES (client + server) — see src/rules/random.js for usage/bundling.
// Self-contained: `cards`/`heros` data tables are passed in, not imported.
// =============================================================================

// Deck-builder filter options (browser UI). Sorted, with "None" forced first.
export const cardFilters = ["None", ...["Fluffle", "Canine", "Feline", "Greenskin", "Livestock", "Rodent", "Event", "Elf", "Farming", "Horny", "Creature", "Mating", "Sneaky", "Magical", "Stoned", "Avian", "Flier", "Nesting", "Shuffle", "Event Trigger", "Harvest Trigger", "Hatch Trigger"].sort()];

/**
 * Check that a whole deck is legal for its hero (size, per-card limits, tribe).
 * @param {object} deck    { hero, list:[{id}] }
 * @param {object[]} cards Card data table.
 * @param {object[]} heros Hero data table.
 * @returns {true|string}  true, or a human-readable reason.
 */
export function VerifyDeck(deck, cards, heros) {
	var hero = heros[deck.hero];
	if (deck.list.length != hero.decksize && hero.name != "Testy, McTestface") {
		return "Not Correct Deck Size";
	}
	var deckFail = false;
	var cardQuantities = {};
	// `card` is declared here (the old non-strict code left it implicit).
	for (var card of deck.list) {
		if (VerifyCard(card, deck, cards, heros) !== true) {
			return VerifyCard(card, deck, cards, heros);
		}
		cardQuantities[card.id] = (cardQuantities[card.id] || 0) + 1;
		if (cardQuantities[card.id] > cards[card.id].limit && hero.name != "Testy, McTestface") {
			return cards[card.id].limit + " Or Less Per Card";
		}
	}
	console.log("Verify The Deck with hero: " + hero.name);
	return true;
}

/**
 * Check a single card: matches a deck-builder filter, and is legal for the hero.
 * @returns {true|false|string}  true legal; string reason; false = no filter match.
 */
export function VerifyCard(card, deck, cards, heros, cardFilter = "None") {
	if (!deck) {
		deck = { hero: 0 };
	}
	if (cardFilter != "None") {
		var theCard = cards[card.id];
		if (cardFilter == "Shuffle") {
			if (theCard.text.toLowerCase().includes("shuffl") == false) {
				return false;
			}
		} else if (cardFilter == "Event") {
			if (!theCard.event) {
				return false;
			}
		} else if (cardFilter == "Creature") {
			if (!theCard.creature) {
				return false;
			}
		} else if (cardFilter == "Event Trigger") {
			if (!theCard.triggers.event) {
				return false;
			}
		} else if (cardFilter == "Harvest Trigger") {
			if (!theCard.triggers.crop && !theCard.triggers.firstCrop) {
				return false;
			}
		} else if (cardFilter == "Hatch Trigger") {
			if (!theCard.triggers.hatch) {
				return false;
			}
		} else {
			if (!theCard.tags.includes(cardFilter) && !theCard.keywords[cardFilter.toLowerCase()]) {
				return false;
			}
		}
	}
	var hero = heros[deck.hero];
	if (cards[card.id].event && deck.hero == 7) {//Dragon
		return "No Events, You Dork";
	}
	if (cards[card.id].creature && deck.hero == 2 && !cards[card.id].tags.some(tag => ["Livestock", "Feline", "Canine"].includes(tag))) {//Centaur
		return "Wrong Creature Tribe";
	}
	if (cards[card.id].keywords.flier && deck.hero == 8) {//Kobold
		return "No Fliers, You Dork";
	}
	if (cards[card.id].tags.some(item => hero.restrictions.includes(item))) {
		return "Specific Card Not Allowed";
	}
	console.log("Verification Approved: " + card.name);
	return true;
}
